
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Blur from 'vux/src/components/blur/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


const CHECK_REG = /^\d+(\.\d+)?$/

export default {
components: {
Blur,
XHeader,
Card,
Divider,
Cell,
CellFormPreview,
CellBox,
Badge,
Group,
Loading,
XTextarea,
XInput,
XSwitch,
XButton,
Toast,
Swiper,
SwiperItem,
Confirm,
ConfirmPlugin
},
data () {
return {
data: {
orderCountPrice: 0,
order_goods: [],
all_cost_: 0,
discount: 0,
shipping_price: 0,
order_id: ''
},
show4: false,
str: ''
}
},
created () {
const orderId = this.$route.query.order_id
this.$store.dispatch('getOrderGoodsInfo', orderId).then((res) => {






this.data.orderCountPrice = this.roundValue(parseFloat(res.data.order_amount))
this.data.shipping_price = res.data.shipping_price
this.data.order_id = res.data.order_id
res.data.order_goods.forEach((e) => {
this.data.order_goods.push({
goods_discount: parseFloat(e.goods_discount),
rec_id: e.rec_id,
goods_name: e.goods_name,
goods_num: e.goods_num,
original_img: e.original_img,
final_price: parseFloat(e.final_price) - parseFloat(e.goods_discount), // 计算de原价
final_prices: this.roundValue(parseFloat(e.final_price) - parseFloat(e.goods_discount)), // 显示原价
costPrice: this.roundValue(parseFloat(e.final_price) * (1 - (e.commission / 100))), // 单商品结算
spec_key_name: e.spec_key_name,
commission: e.commission,
new_price: this.roundValue(parseFloat(e.final_price)) 
})
})

})
},
methods: {

changeNewPrice (val, key, index) {
const that = this
setTimeout(() => {
if (val && typeof val === 'string') {
that.data.order_goods[index][key] = val.replace(/[^\d.]/g, '')




}
}, 0)
let countPriceOne = 0
let discount = 0
let newPrice = 0
this.data.order_goods.forEach((e) => {
newPrice += parseFloat(e.new_price) * e.goods_num 
e.costPrice = this.roundValue(parseFloat(e.new_price) * (1 - (e.commission / 100))) 
countPriceOne += e.costPrice * e.goods_num 
e.goods_discount = (e.final_prices - e.new_price) * e.goods_num 
discount += e.goods_discount 
})
this.data.all_cost_ = this.roundValue(countPriceOne)
this.data.discount = this.roundValue(discount) * -1
this.data.orderCountPrice = this.roundValue(newPrice + parseFloat(this.data.shipping_price))
},
checkData: function (val) {
return {
valid: CHECK_REG.test(val), // 此处不能调用 this.checkVal
msg: '格式不正确'
}
},
orderGoodsSubimt () {
this.show4 = false
let reStatus = 1
let str = ''
this.data.order_goods.forEach((e) => {
if (e.new_price === '' || e.new_price < 0) {
reStatus = 0
str = '新实付单价不能为空或小于0'
return
}
if (e.new_price > e.final_prices) {
reStatus = 0
str = '新实付单价不能大于原实付单价'
}
})
if (!reStatus) {
this.$vux.toast.text(str)
return
}
this.data.order_goods.forEach((e) => {
if ((e.final_prices - e.new_price) / e.final_prices * 100 > 10) {
this.show4 = true
}
})
if (this.show4 === false) {
this.onConfirm4()
}
},
onConfirm4 () {
this.$store.dispatch('editOrderGoods', this.data).then((res) => {
if (res.status === 1) {
this.$vux.toast.text(res.msg)
} else {
this.$vux.toast.text(res.msg)
}
this.$vux.loading.hide()
this.show4 = false
})
},

roundValue (val) {
return Math.round(val * 100) / 100
}
}
}



// WEBPACK FOOTER //
// ./src/components/order/OrderEdit.vue